import React from 'react';
import styled from 'styled-components';
import architecture from '../../assets/project/accelerating_architecture.png';

const FutureplayProject = () => {
  return (
    <Container>
      <div className='box-tag'>엑셀러레이팅 플랫폼</div>
      <div className='box-heading'>
        스타트업 성장을 위해
        <br />
        엑셀러레이팅.
      </div>
      <div className='box-detail'>
        <div className='box-desc-heading'>
          스타트업의 진행 상황 트랙킹, 히스토리, 외부평가, 사업계획서, 투자 현황
          등 다양한 관점에서의 데이터를 하나의 플랫폼에서 관리할 수 있는 서비스
          <div className='box-desc-list'>
            <div className='box-desc-list-item'>
              Infrastructure
              <br />
              as Code (IaC)
            </div>
            <div className='box-desc-list-item'>
              Behavior Driven Development Test
              <br />
              행동 주도 개발
            </div>
          </div>
        </div>
      </div>
      <div className='img-box'>
        <img
          src={architecture}
          alt='enterprise search'
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  grid-column: span 2;
  align-self: stretch;

  .img-box {
    text-align: center;
    margin-top: 48px;

    img {
      width: 100%;
      border-radius: 25px;
    }
  }

  background: linear-gradient(30deg, #214079 1%, #663a7e 55%, #a82b7d 100%);
  border-radius: 25px;
  text-align: left;
  padding: 40px;

  .box-tag {
    margin-bottom: 40px;
    color: #fff;
    font-size: 19px;
    font-weight: 600;
  }

  .box-heading {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-sub-heading {
    font-size: 64px;
    font-weight: 700;
    margin: 0;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-detail {
    font-size: 19px;

    .box-desc-heading {
      color: #fff;
      margin-bottom: 8px;
    }

    .box-description {
      margin: 0;
    }

    .box-desc-list {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 48px;
      font-size: 36px;
      font-weight: 700;

      .box-desc-list-item {
        padding: 12px 18px;
        text-align: center;
      }
    }
  }

  @media only screen and (min-width: 769px) {
    grid-column: span 1;

    .box-detail {
      .box-desc-list {
        font-size: 48px;
      }
    }
  }

  @media only screen and (min-width: 1025px) {
    .box-detail {
      .box-desc-list {
        font-size: 56px;
      }
    }
  }
`;

export default FutureplayProject;
